import { useEffect, useState } from 'react';

import { storage, StorageKeys } from '@/services/storage';
import { logout } from '@/store/authActions';
import { useAppDispatch } from '@/store/hooks';

export const useLogoutOnMount = (): boolean => {
  const dispatch = useAppDispatch();
  const [wasLoggedInOnMount] = useState(() =>
    Boolean(storage.get(StorageKeys.GxToken) || storage.get(StorageKeys.TripToken))
  );

  useEffect(() => {
    if (!wasLoggedInOnMount) return;

    dispatch(logout());
  }, [dispatch, wasLoggedInOnMount]);

  return wasLoggedInOnMount;
};
